module.exports = __webpack_public_path__ + "static/media/tirupati-laddu.6bbc0755.jpg";